import { useI18n } from '../lib/i18n';

export function Footer({ embed, onOpenMethodology }: { embed: boolean; onOpenMethodology: () => void }) {
  const { t, setLang, lang } = useI18n();

  if (embed) {
    return (
      <footer className="border-t border-an-rule bg-an-white">
        <div className="mx-auto max-w-[1400px] px-4 py-3 md:px-6">
          <p className="font-body text-xs text-an-muted">{t('app.footer.citation')}</p>
          <MutinyCredit label={t('app.footer.producedBy')} />
        </div>
      </footer>
    );
  }

  return (
    <footer className="border-t border-an-rule bg-an-white helix-bg">
      <div className="mx-auto max-w-[1400px] px-4 py-6 md:px-6">
        <p className="font-body text-sm text-an-ink">{t('app.footer.citation')}</p>
        <div className="my-4 h-px w-full bg-an-rule" />
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
          <div className="flex items-center gap-3">
            <img src="/logos/archivo-negro.png" alt="Archivo Negro" className="h-8 w-auto" />
            <span className="font-body text-xs text-an-muted">
              {t('app.cobrand.tagline')}
            </span>
          </div>
          <nav className="flex flex-wrap gap-x-5 gap-y-1 text-sm">
            <button className="underline decoration-transparent hover:decoration-an-black" onClick={onOpenMethodology}>
              {t('app.footer.nav.methodology')}
            </button>
            <a
              className="underline decoration-transparent hover:decoration-an-black"
              href="/data/municipios.json"
              download
            >
              {t('app.footer.nav.download')}
            </a>
            <a
              className="underline decoration-transparent hover:decoration-an-black"
              href="/data/municipios.json"
            >
              {t('app.footer.nav.api')}
            </a>
            <a
              className="underline decoration-transparent hover:decoration-an-black"
              href="mailto:archivo@movimientoananse.org"
            >
              {t('app.footer.nav.contact')}
            </a>
            <button
              className="underline decoration-transparent hover:decoration-an-black"
              onClick={() => setLang(lang === 'es' ? 'en' : 'es')}
            >
              {t('app.footer.nav.language')}
            </button>
          </nav>
        </div>

        <p className="mt-6 font-body text-xs text-an-muted">{t('app.footer.copyright')}</p>

        <div className="mt-4 h-px w-full bg-an-rule/40" />
        <div className="mt-4 flex justify-center md:justify-end">
          <MutinyCredit label={t('app.footer.producedBy')} />
        </div>
      </div>
    </footer>
  );
}

function MutinyCredit({ label }: { label: string }) {
  // Mirrors the canonical Mutiny credit lockup from fundacionrimas.org:
  // small "Produced by", tiny inline logo, "Mutiny Labs" as plain text,
  // all at 60% opacity and fading to full on hover.
  return (
    <a
      href="https://mutiny-labs.com"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center justify-center gap-1 text-xs text-an-ink opacity-60 transition-opacity hover:opacity-100"
    >
      <span>{label}</span>
      <img
        src="/logos/mutiny-labs.png"
        alt="Mutiny Labs"
        className="inline-block h-3 w-auto"
        style={{ filter: 'brightness(0) invert(45%)' }}
        loading="lazy"
      />
      <span>Mutiny Labs</span>
    </a>
  );
}
